/* Theme-owned enhancements: native Liquid remains the initial storefront. */
(() => {
  document.addEventListener('scroll', event => {
    const frames = event.target;
    if (!(frames instanceof HTMLElement) || !frames.matches('.k15-card-frames')) return;
    const media = frames.closest('.product-card__media');
    media.dataset.k15Slide = String(Math.round(frames.scrollLeft / Math.max(1, frames.clientWidth)));
  }, true);
  document.addEventListener('keydown',event=>{
    const gallery=event.target.closest?.('.k15-card-frames');
    if(!gallery||event.altKey||event.ctrlKey||event.metaKey||!['ArrowLeft','ArrowRight'].includes(event.key))return;
    event.preventDefault();gallery.scrollBy({left:(event.key==='ArrowRight'?1:-1)*gallery.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
  });
  let pointer;
  document.addEventListener('pointerdown', event => {
    const frames = event.target.closest?.('.k15-card-frames');
    pointer = frames ? {frames, x:event.clientX, y:event.clientY} : null;
  }, {passive:true});
  document.addEventListener('click', event => {
    if (pointer && pointer.frames.contains(event.target) && (Math.abs(event.clientX-pointer.x)>10 || Math.abs(event.clientY-pointer.y)>10)) event.preventDefault();
    pointer = null;
  }, true);
  document.addEventListener('click', event => {
    if (event.target.closest('.desktop-nav summary')) {
      const current = event.target.closest('details');
      for (const details of document.querySelectorAll('.desktop-nav details[open]')) if (details !== current) details.open=false;
    } else if (!event.target.closest('.desktop-nav')) {
      for (const details of document.querySelectorAll('.desktop-nav details[open]')) details.open=false;
    }
  });
  document.addEventListener('focusin',event=>{for(const details of document.querySelectorAll('.desktop-nav details[open]'))if(!details.contains(event.target))details.open=false;});
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    for (const details of document.querySelectorAll('.desktop-nav details[open]')) {details.open=false;details.querySelector('summary').focus();}
  });
  // Preserve Shopify order for manual collections and every explicit native sort.
  const normalizeType = product => {
    const type = product.type.toLocaleLowerCase('lt');
    const handle = product.handle;
    if (handle.includes('su-uztrauktuku')) return 'Su užtrauktuku';
    if (type.includes('vaikišk') || type==='kids clothes') return 'Vaikams';
    if (type.includes('kūdiki') || type.includes('smėlinuk') || handle.includes('smelinuk')) return 'Smėlinukas';
    if (type.includes('marškin') || type==='t-shirt') return 'Marškinėliai';
    if (type.includes('džemper') || ['hoodie','sweatshirt'].includes(type)) return 'Džemperiai';
    if (['puodeliai','puodelis','mug'].includes(type)) return 'Puodeliai';
    if (type.includes('kepur')) return 'Kepurės';
    if (type.includes('kojin')) return 'Kojinės';
    if (type.includes('prijuost')) return 'Prijuostės';
    if (type.includes('krepš') || type==='bags') return 'Krepšiai';
    return product.type;
  };
  class KukurGiftFilters extends HTMLElement {
    static matchesType(item,type) {
      const normalized=normalizeType(item);
      const house=['Puodelis','Prijuostė','Pelės kilimėlis','Pledas','Plakatas','Drobės paveikslas','Dekoratyvinė pagalvėlė','Kvapioji žvakė','Sieninis laikrodis','Stiklinė','Pjaustymo lentelė'];
      const work=['Užrašinė','Darbo kalendorius','Pelės kilimėlis','Didelis stalo kilimėlis','Nešiojamojo kompiuterio dėklas'];
      return !type || item.type===type || normalized===type || (type==='Vaikams'&&normalized==='Smėlinukas') || (type==='Aksesuarai'&&['Krepšys','Bags','Kojinės','Prijuostė','Apron','Kepurė'].includes(item.type)) || (type==='Namams'&&house.includes(item.type)) || (type==='Darbui'&&work.includes(item.type));
    }
    async prepare() {
      if(this.items){this.populateExtraFilters();return;}
      this.setAttribute('aria-busy','true');
      this.loading.textContent=this.messages.loading;
      try { await this.catalogue(); if(this.isConnected){this.populateExtraFilters();this.loading.textContent='';} }
      catch(error) { if(error.name!=='AbortError')this.loading.textContent=this.messages.error; }
      finally { this.removeAttribute('aria-busy'); }
    }
    connectedCallback() {
      if (this.controller) return;
      this.controller=new AbortController();
      this.fields=[...this.querySelectorAll('select')];
      this.grid=document.querySelector('.collection-section .catalog-results .product-grid');
      this.results=document.querySelector('.collection-section [data-k15-results]');
      this.status=this.results.querySelector('[data-k15-status]');
      this.count=document.querySelector('.collection-count');
      this.initialCount=this.count?.textContent;
      this.messages=JSON.parse(this.querySelector('[data-k15-messages]').textContent);
      this.loading=this.querySelector('[data-k15-loading]');
      this.more=this.results.querySelector('[data-k15-more]');
      const params=new URL(location.href).searchParams;
      if(params.get('k15_type')==='Kūdikiams')params.set('k15_type','Smėlinukas');
      this.recipientOptions=[...this.fields[1].options].filter(option=>option.value).map(option=>({value:option.value,label:option.textContent}));
      this.fields.forEach(field=>{field.dataset.selected=params.get(field.name)||field.value;field.value=field.dataset.selected;});
      this.fields.forEach(field=>field.addEventListener('change',()=>this.apply(),{signal:this.controller.signal}));
      this.more.addEventListener('click',()=>{const previous=this.limit;this.limit+=24;this.render();this.grid.children[previous]?.querySelector('a')?.focus();},{signal:this.controller.signal});
      this.querySelector('[data-k15-clear]').addEventListener('click',()=>{this.fields.forEach(field=>field.value='');this.apply();},{signal:this.controller.signal});
      this.querySelectorAll('[data-k15-quick]').forEach(link=>link.addEventListener('click',event=>{
        event.preventDefault();this.fields.forEach(field=>field.value='');
        const field=link.dataset.k15Field==='type'?this.fields[0]:this.fields[1];
        field.value=link.dataset.k15Value;this.apply();
      },{signal:this.controller.signal}));
      if(this.fields.some(field=>params.has(field.name))) this.apply(false);
      this.addEventListener('focusin',()=>this.prepare(),{signal:this.controller.signal});
      this.addEventListener('pointerenter',()=>this.prepare(),{signal:this.controller.signal});
      this.prepare();
    }
    disconnectedCallback(){this.controller?.abort();this.controller=null;this.pending=null;}
    async catalogue() {
      if(this.items) return this.items;
      if(this.pending) return this.pending;
      const signal=this.controller.signal;
      const pending=this.pending=(async()=>{
        const items=[];let page=1,pages=1;
        do {
          const url=new URL(location.href);for(const field of this.fields)url.searchParams.delete(field.name);url.searchParams.set('view','k15-data');url.searchParams.set('page',page);if(url.searchParams.has('sort_by'))url.searchParams.set('sort_by',url.searchParams.get('sort_by'));
          const response=await fetch(url,{signal,credentials:'same-origin'});
          if(!response.ok)throw Error('Catalogue unavailable');
          const data=await response.json();items.push(...data.products);pages=data.pages;page++;
        }while(page<=pages);
        this.items=items;return items;
      })();
      try{return await pending;}finally{if(this.pending===pending)this.pending=null;}
    }
    populateExtraFilters(){
      if(!this.items||this.hasAttribute('data-k15-ready'))return;
      const populate=(field,values)=>{
        const selected=field.dataset.selected||field.value;
        while(field.options.length>1)field.remove(1);
        for(const {value,label,count} of values){const option=document.createElement('option');option.value=value;option.textContent=label+' ('+count+')';field.append(option);}
        field.value=selected;field.disabled=!values.length;field.closest('label').hidden=field.disabled;
      };
      const types=new Map();for(const item of this.items)if(item.type)types.set(item.type,(types.get(item.type)||0)+1);
      populate(this.fields[0],[...types].sort(([a],[b])=>a.localeCompare(b,'lt')).map(([value,count])=>({value,label:value,count})));
      populate(this.fields[1],this.recipientOptions.map(({value,label})=>({value,label,count:this.items.filter(item=>KukurGiftFilters.matchesRecipient(item,value)).length})).filter(option=>option.count>0));
      for(const field of this.fields.slice(2)){
        const prefix=field.name==='k17_occasion'?/^(proga[-:]|occasion:)/:field.name==='k17_style'?/^(stilius:|style:)/:/^(pomegis[-:]|pomėgis:|profesija[-:]|tema[-:])/;
        const counts=new Map();for(const item of this.items)for(const tag of new Set(item.tags))if(prefix.test(tag))counts.set(tag,(counts.get(tag)||0)+1);
        populate(field,[...counts].sort(([a],[b])=>a.localeCompare(b,'lt')).map(([value,count])=>({value,label:value.replace(prefix,'').replaceAll('-',' '),count})));
      }
      this.toggleAttribute('data-k15-ready',true);
      const nativeType=this.closest('k-filters')?.querySelector('input[name="filter.p.product_type"]')?.closest('fieldset');
      if(nativeType)nativeType.hidden=!this.fields[0].disabled;
    }
    static matchesRecipient(item,recipient){return !recipient||[recipient,'gavejas:'+recipient,'gavėjas:'+recipient].some(tag=>item.tags.includes(tag));}
    async apply(updateUrl=true) {
      this.request=(this.request||0)+1;const request=this.request;
      this.status.textContent=this.messages.loading;this.grid.setAttribute('aria-busy','true');
      try {
        const items=await this.catalogue();if(!this.isConnected||request!==this.request)return;
        this.populateExtraFilters();
        const type=this.fields[0].value,recipient=this.fields[1].value;
        this.toggleAttribute('data-k15-active',this.fields.some(field=>field.value));
        this.filtered=items.filter(item=>KukurGiftFilters.matchesType(item,type) && KukurGiftFilters.matchesRecipient(item,recipient) && this.fields.slice(2).every(field=>!field.value||item.tags.includes(field.value)));
        this.limit=24;this.render();
        if(updateUrl){const url=new URL(location.href);for(const field of this.fields)field.value?url.searchParams.set(field.name,field.value):url.searchParams.delete(field.name);url.searchParams.delete('page');history.replaceState({},'',url);}
        document.querySelectorAll('[data-k15-quick]').forEach(link=>link.setAttribute('aria-current',(link.dataset.k15Field==='type'?type:recipient)===link.dataset.k15Value?'page':'false'));
        for(const form of document.querySelectorAll('.filter-form,[data-sort-form]'))for(const field of this.fields){let hidden=form.querySelector(`input[name="${field.name}"]`);if(!hidden){hidden=document.createElement('input');hidden.type='hidden';hidden.name=field.name;form.append(hidden);}hidden.value=field.value;}
      }catch(error){if(error.name!=='AbortError')this.status.textContent=this.messages.error;}
      finally{if(request===this.request)this.grid.removeAttribute('aria-busy');}
    }
    render(){
      const markup=this.filtered.slice(0,this.limit).map(item=>item.html).join('');
      const fragment=document.createRange().createContextualFragment(markup);
      this.grid.replaceChildren(fragment);
      const nativeEmpty=this.grid.parentElement.querySelector(':scope > .empty-state');if(nativeEmpty)nativeEmpty.hidden=true;
      this.status.textContent=this.messages.count+this.filtered.length;
      if(this.count)this.count.textContent=this.messages.count+this.filtered.length;
      this.more.hidden=this.filtered.length<=this.limit;
      const empty=this.results.querySelector('[data-k15-empty]');empty.hidden=this.filtered.length>0;
      const pagination=document.querySelector('.collection-section .pagination');if(pagination)pagination.hidden=true;
    }
  }
  if(!customElements.get('k15-gift-filters')) customElements.define('k15-gift-filters',KukurGiftFilters);
  // Keep image 1 meaningful when task 11 supplies a model/lifestyle primary card image.
  for(const card of document.querySelectorAll('.product-card')) {
    const image=card.querySelector('.k15-card-frame img');
    if(image && /lifestyle|gyvenimo|modelis|modelio|žmog/iu.test(image.alt)){card.querySelector('.product-card__media').classList.remove('k-zoom');image.style.objectFit='cover';}
  }
})();
